import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProductPayMethodTypeEditConfirmModal from '../../../../views/product/common/modal/ProductPayMethodTypeEditConfirmModal';
import { productActions } from '../../../../store/modules/product';
import withModal from '../../../../lib/hoc/withModal';

class ProductPayMethodTypeEditConfirmModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'productPayMethodTypeEditConfirmModal',
      value: false,
    });
  };

  onSubmit = () => {
    const { onSubmit } = this.props.data;

    onSubmit();

    this.closeModal();
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <ProductPayMethodTypeEditConfirmModal
        isOpen={isOpen}
        data={data}
        closeModal={this.closeModal}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.product.productPayMethodTypeEditConfirmModal.isOpen,
    data: state.product.productPayMethodTypeEditConfirmModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: productActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ProductPayMethodTypeEditConfirmModalContainer));
